var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrangePawBackground = function SvgOrangePawBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1641,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M70.48 1085.56c11.858 7.45 10.795 6 20.088-.95 9.948-7.43 17.688-15.83 24.146-26.21 1.908-3.11 8.394-5.83 11.883-4.96 6.406 1.61 11.584-.35 17.389-1.41 4.661-.84 9.677.41 16.11.85.245-1.18.899-4.5 1.308-6.65 8.394-2.34 16.135-4.52 23.902-6.67 9.516 13.87 21.156 18.2 37.428 14.64 2.78-.6 7.332-.03 8.832 1.8 3.707 4.63 11.338.05 13.656 6.57 3.298-1.28 6.597-2.56 10.985-4.28.192 5.7-5.34 13.08 4.882 16.49 1.28-1.12 3.025-3.19 5.205-4.28 2.235-1.09 4.961-1.14 7.877-1.77-2.56 11.94-2.014 13.25 7.963 17.45 7.36 3.11 16.845 2.07 21.017 11.15 21.098 6.54 37.592 22.22 58.336 29.39 1.718.57 3.299 1.61 5.616 2.78-.572 3.51-1.144 6.98-1.77 10.71 1.799.44 3.381 1.42 4.307.98 7.413-3.65 14.174-2.88 21.043 1.7 2.481 1.66 6.161 1.41 9.132 2.48 2.862 1.06 6.433 2.07 8.041 4.28 2.454 3.38 4.799 4.41 8.997 4.96 10.058 1.34 11.203 4.77 6.462 15.24 8.669 2.61 17.392 5.23 26.714 8.07-1.335 3.62-2.179 6.05-3.187 8.8 1.417.49 2.672 1.31 3.898 1.28 10.548-.24 20.77 1.15 30.665 5.1 7.197 2.89 10.769 7.12 6.845 14.7.981.87 1.772 2.04 2.345 1.96 7.113-1.17 5.861 7.38 10.55 8.91 4.225 1.39 8.832 2.07 12.621 4.17 8.232 4.58 13.059 15.95 25.351 12.38.463-.13 1.336 1.12 2.045 1.72 21.7 18.75 39.503 39.77 44.224 69.5 1.583 10.03 5.565 19.68 8.266 29.52 1.363 4.96 2.672 9.92 3.382 14.99 1.828 12.95 1.91 13.25 14.422 15.13 3.49 8.23-6.158 8.99-8.692 14.91 2.017 1.03 3.871 1.96 6.352 3.24a712 712 0 0 0-3.597 6.21c4.362 5.4 9.432 10.14 12.595 15.92 2.972 5.43 3.955 11.91 4.065 19.44-2.835-2.13-5.643-4.23-9.65-7.26.111 8.62 5.563 14.01 8.018 20.99 3.106-5.61 6.867-10.41 8.419-15.83 1.471-5.18.624-11.04.868-17.99 8.996 5.07 6.218 11.83 7.473 18.7 3.244 1.06 7.087 3.21 10.903 3.22 2.617 0 6.079-2.54 7.55-4.94.953-1.55-.274-5.45-1.746-7.3-7.961-10.08-8.097-10 5.285-12.37-1.037-8.78-5.726-13.96-14.122-16.79-6.869-2.35-14.474-4.45-15.975-14.18-2.671 1.58-4.878 2.86-6.977 4.09-4.607-3.25-1.665-9.02 6.021-11.86 5.615-2.07 11.366-3.84 18.289-6.12-2.481-3.46-4.472-6.22-6.489-9 3.505-8.48 10.383-8.78 20.633-.89-6.352-8.64-2.566-17.07 2.148-28.65-9.648 8.07-16.163 5.75-22.569 1.69 1.28-4.83 2.533-9.68 3.759-14.34 10.712-1.11 16.546 6.14 22.817 13.66 3.461-3.84 5.86-6.51 8.176-9.1.189-10.98-7.77-7.93-12.84-7.66-8.751-8.15-2.649-24.01-18.403-26.41 4.168-9.35 6.729-17.47-2.295-24.31 3.352-2.97 5.641-4.99 9.13-8.1.491 3.98.792 6.41 1.147 9.54 11.038-2.47 5.148-12.56 8.909-18.61 6.65-3.87 19.162-.57 20.276-16.13-4.251 3.32-7.113 5.59-11.174 8.77-.764-3.38-1.364-6.05-1.964-8.72-9.431-1.51-13.793-6.65-13.086-15.43 2.29 3.38 4.116 6.03 6.298 9.24 2.56-8.5 4.795-15.86 7.028-23.21v.1c4.235 3.8 3.491 8.51-2.232 14.12 6.869.55 12.674 1.01 20.66 1.64-5.971-10.93-.03-16.49 6.238-23.03 3.926 2.73 7.579 5.29 11.968 8.37 3.08-2.97 3.106-6.27 1.47-10.68-1.173-3.13-2.073-8.45-.411-10.22 6.077-6.46 4.359-13.3 3.295-18.72-5.016-2.68-9.105-4.86-14.775-7.86.819 7.64 1.529 14.34 2.321 21.67-8.803 5.26-15.646 2.67-17.147-7.99-.519-3.57-.955-7.44-.029-10.82 2.724-10.08 6.292-19.97 1.984-30.82 1.145-.16 2.262-.35 3.407-.52 2.236 7.52 4.473 15.05 7.009 23.47 2.208-1.72 4.715-3.73 7.359-5.78 3.462 2.97 6.679 5.75 12.186 10.5-2.073-10.63-3.547-18.1-5.02-25.51q-10.93 1.875-14.83-9.54c3.298-.19 6.296-.85 9.131-.47 10.521 1.37 9.24.85 12.346-8.69 2.697-8.31 8.583-15.99 14.469-22.7 2.017-2.29 8.368-.73 13.983-1-9.351-12.08-22.871-10.39-35.164-11.67.191 2.42.492 6.21.929 12.04-5.915-3.84-10.032-6.54-14.994-9.76 1.744-3.81 3.352-7.38 5.45-12.04-4.444-4.06-9.133-8.32-14.449-13.14 1.852-3.49 3.052-7.14 5.45-9.7 1.526-1.64 4.906-2.56 7.141-2.18 1.472.22 3.68 3.57 3.462 5.2-1.415 10.58 5.4 13.8 17.04 17.42-4.117-5.75-6.435-8.99-9.352-13.05 13.654-6.79 28.865.08 43.119-5.66-2.835-4.53-5.671-9.05-9.461-15.19 4.961-1.03 8.695-1.77 12.947-2.64 5.205-4.55 1.415-13.95-11.426-26.844 11.01-8.338 11.091-13.052.187-19.486 5.695-10.71 14.934-16.567 26.6-20.054.436 3.107.791 5.697 1.31 9.485 3.679-3.242 6.595-5.831 10.11-8.965a677 677 0 0 1-2.672-4.034c5.586-11.909 10.9-23.163 17.384-36.952 6.132-4.441 15.155-.161 24.777 1.776-.055-2.671-1.064-5.642-.028-6.841 9.81-11.335 9.892-11.254 9.344-24.009 15.265 3.982 24.338-12.886 41.865-9.858-2.808-3.734-4.171-5.587-6.134-8.204l17.305-17.303c6.188.955 13.002 1.993 20.689 3.139 1.143-10.902 7.411-15.642 19.813-14.959.928 4.524 1.938 9.512 2.974 14.472 2.602-.433 5.312-.866 8.022-1.299l-.008-.008-.572.082c6.35-4.168 12.7-8.337 20.903-13.759.082.627-.163-1.472-.655-5.287 6.46-2.588 13.819-4.658 20.169-8.391 3.87-2.288 6.159-7.248 10.628-12.806.846 4.769 1.555 8.53 2.264 12.564 7.877-.353 16.085-2.232 23.665-.759 12.62 2.482 21.04-.378 26.57-12.395 1.58-3.379 6.24-5.314 8.86-7.384 5.64 1.173 10.44 2.209 15.75 3.328 6.24 9.131-9.21 14.933-3.18 24.391 2.23-2.234 4.63-4.905 7.36-7.248 2.01-1.744 4.38-4.387 6.59-4.414 9.57-.025 19.08 1.312 28.51-1.902 3.38-1.144 7.36-.489 13.79-.815-.46 1.662-1.96 4.305-1.66 6.731.19 1.608 2.92 2.917 4.42 4.198 4.06-6.022 8.23-11.009 11.01-16.677 1.82-3.734 1.68-8.394 2.45-12.918q8.07-.434 12.18 8.479c-3.54 4.85-13.41 6.102-9.67 17.032 12.32-6.43 24.86-15.149 35.9.142 4.5-2.127 8.25-3.883 11.94-5.633-1.05 3.332-2.13 6.687-2.95 9.288 10.53 2.4 20.83 4.745 31.08 7.091-1.15-7.195 5.8-4.769 9.62-6.512l-.06-.055c11.02 2.4 20.26-2.911 29.66-6.098 2.18 2.453 4.25 6.923 7.44 7.932 11.42 3.681 23.17 6.381 34.92 8.918 2.1.464 4.82-1.443 7.17-2.478 3.95-1.771 7.71-5.204 11.69-5.367 13-.624 25.7.849 36.15 10.254 3.19 2.862 7.11 4.88 12.43 8.397.21-5.833.38-9.212.49-12.646 5.17 1.545 6.18 6.461 3.02 14.745 6.41 4.988 13.17 10.277 19.93 15.511 13.66-10.599 24.04-7.299 31.59 9.899 6.03-1.28 11.43-4.004 17.97 1.666 5.61 4.852 13.9 2.673 21.72-.514-3.81 4.197-7.57 8.393-11.99 13.243 6.54 1.582 12.35 3.028 18.97 4.637-.43-4.524-.84-8.749-1.5-15.835 5.59 4.008 9.16 6.543 12.68 9.133 6.16 4.471 10.96 12.212 20.5 8.67 9.59 8.941 24.34 7.282 33.94 17.858 7.55 8.314 18.45 13.821 28.4 19.627 16.63 9.76 21.32 25.46 23.45 42.957 1.01 8.149 2.38 16.325 4.45 24.284.71 2.78 3.54 5.83 6.21 7.14 6.27 3 9.46 7.23 7.39 15.35 5.91.4 10.86.75 15.77 1.08.01-.03.03-.05.04-.08l.06.09h.05-.11c3 8.5 7.04 16.79 8.65 25.54 1.34 7.06 3.74 12.13 10.22 15.51 1.42-2.35 2.73-4.47 3.87-6.38 1.89 7.77 3.55 15.21 5.65 22.54.6 2.07 2.1 4.55 3.9 5.59 11.17 6.43 12.84 17.36 14.18 28.56 12.32 4.2 13.87 16.22 17.23 26.01 3.35 9.84 4.06 20.63 5.21 31.09.3 2.92-1.2 6.65-3.08 9.08-5.17 6.54-5.17 14.66-4.63 21.58.52 6.57-.92 10.69-5.17 14.72-7.8 7.46-15.15 14.71-15.92 26.87-.27 4.09-6.29 7.82-7.93 9.73-9.62 4-17.22 7.13-24.12 9.99-1.09 7.14-1.98 13.06-3.07 20.09 2.12.27 4.63.6 7.11.95-1.47 8.34 2.7 18.78-4.52 25.08-7.14 6.21-16.62 9.75-26.22 15.09-.27 6.54-.98 14.28-9.75 18.15-1.96.87-2.92 4.6-3.84 7.17-1.61 4.55-4.64 6.92-9.38 6.86-6.32-.05-10.47 2.94-13.11 8.64-2.26 4.93-8.61 5.94-11.31 8.91-7.57 8.34-19.21 6.34-27.12 13.27-3.35 2.97-9.59 3.32-14.58 3.73-9.89.79-17.99 4.03-21.94 14.3-7.22-9.08-11.97-10.71-16.95-4.2-6.38 8.34-13.88 6.67-21.94 6.02-3.41-.3-6.9.08-11.53.13.95 5.97 1.63 10.25 2.59 16.33-6.76-8.18-13.47-10.85-21.26-4.2-16.55-3.3-25.4 13.24-40.42 15.61-7.99 1.28-16.36 8.93-21.56 15.94-3.43 4.63-7.31.43-9.05 3.26-2.59 4.28-4.49 9.02-6.84 13.98-10.71 5.53-20.14-2.43-31.45-3.11-4.28 4.66-9.49 10.36-14.96 16.38.51 6.46 1.06 13.43 1.74 21.96-16.43-5.69-16.35 11.77-27.14 16.02 2.89 3.28 4.91 5.56 7.69 8.73-2.27.9-4.2 1.63-6.82 2.67-2.07 5.56 3.03 14.14-6.34 18.39a974 974 0 0 0-7.77-5.81c-1.66 10.03-3.18 19.05-4.67 28.05h.01c-.54 8.01-1.11 16-1.68 24.8-3.63.68-7.12 1.33-10.58 1.96-.3.73-.84 1.5-.93 2.34-.62 6.35.11 13.14-1.96 18.97-2.53 7.06-8.17 12.32-6.12 21.67.87 3.87-7.23 9.67-12.4 16.05.49 2.01 1.44 5.86 2.83 11.33-4.3.49-8.31 1.83-12.02 1.23-12.48-2.02-13.19-2.02-16.46 8.82-.49 1.64.85 3.79 1.09 5.73.33 2.61.39 5.29.6 8.23 1.97.54 4.53 1.25 8.24 2.29-4.28 5.26-7.96 9.76-12.16 14.88 2.62 2.94 4.91 5.56 6.66 7.52-2.24 4.96-4.34 9.62-6.22 13.84-7.79-8.39-8.56-19.62-1.23-31.47-5.71-13.05-11.02-19.56-15.92-19.52.52 3.52 1.04 6.98 1.5 10.22-15.78 7.66-16.6 9.29-14.58 27.01.27 2.5-.02 5.09-.11 11.12-4.9-7.15-7.85-11.45-11.36-16.6-3.25 4.11-5.97 7.71-8.81 11.2-2.42 2.97-3.05 8.39-10.38 6.56 1.55-2.97 2.91-5.64 4.44-8.53-3.54-2.83-6.9-4.82-10.33.3-2.75 4.12-5.61 8.18-8.5 12.21-1.04 1.47-2.37 3.95-3.54 3.92-9.46-.3-9.54 11.66-17.53 13.05.3 1.68.61 3.34.91 5.02-3.59.32-7.16.62-11.92 1.03 3.08 9.79 2.32 18.62-5.45 25.07a7008 7008 0 0 1-25.59 5.69c1.31-9.15 6.1-19.84-7.96-23.49-5.78 7.85 1.42 10.9 5.59 16.38-4.34 1.23-7.99 2.26-12.4 3.51-1.61-5.47-3.03-10.16-4.34-14.58 3.02-4.49 5.75-8.53 8.47-12.56l-1.55-1.72c-2.64 1.39-5.53 2.43-7.85 4.25-6.78 5.37-13.49 10.49-21.47 14.44-6.246 3.08-11.398 5.45-18.185 3.41-2.099-.63-4.498-.3-7.251-.44-.271 6.32-.515 12.07-.814 18.97-6.106-.28-11.039-.47-16-.69-2.836-6.87-5.454-13.19-8.045-19.48l.01-.02c-15.393 2.84-18.651-.23-17.321-14.41.544-5.99-.956-12.18-1.666-19.59-1.964-3.65-11.585.24-11.177-8.23-2.208.24-4.443.51-6.651.76 2.7 7.49-7.766 8.58-6.784 14.91-9.158 1.52-6.052-5.78-7.798-10.96-4.333 2.26-8.149 4.22-11.938 6.21-2.236-5.65-.046-10.15 6.567-13.49-.001-5.29-.629-10.33.079-15.24.925-6.37-1.392-9.73-8.315-10.16 1.062-3.3 1.879-5.81 2.696-8.31-.927-.33-1.881-1.07-2.507-.88-8.995 2.89-6.922 9.49-4.658 16.65-2.889.33-5.343.6-7.878.9 1.964 6.71 3.819 13.14 5.756 19.87-10.603 1.77-6.381-9.27-12.814-11.99-2.97 1.01-6.759 2.34-11.174 3.86-2.018-3.92-3.328-8.61-6.245-11.8-5.071-5.56-5.071-13.13-1.529-16.68 6.213-6.21 7.357-15.8 15.805-20.76-4.335-3.95-8.505-7.74-13.358-12.16-2.561 4.63-4.578 8.34-6.622 12.07-.954-.24-1.881-.51-2.808-.73.845-4.5 1.689-8.94 2.587-13.71-3.598-2.67-7.305-5.4-11.258-8.26-5.886 9.26-3.186 17.69 1.586 26.05-15.918.44-16.845-.76-12.923-15.7.436-1.69.817-3.7.353-5.31-2.482-8.86-5.182-17.66-8.319-28.05-4.525-1.03-10.304-2.4-16.737-3.87-1.009-3.35-2.154-7.17-3.518-11.69-3.243 1.06-5.806 1.88-8.722 2.83.818 4.03 1.583 7.63 2.32 11.2-8.261-9.89-18.211-12.59-33.093-8.23 6.187-5.21 9.675-8.15 13.545-11.37-.41-6.57-2.429-14.41 5.53-18.17 2.289-1.09 6.296 1.39 11.367 2.7-.982-3.71-.82-9.27-3.11-10.58-8.914-5.21-11.261-22.43-27.314-14.99-5.095 10.98 10.305 14.17 10.198 23.98-7.339 5.11-17.608-.08-24.151 6.86-1-2.88-2.031-5.76-3.624-10.27-2.049 4.85-3.192 7.57-4.324 10.27-5.019-6.05-10.017-12.13-16.176-19.54-4.055 5.73-6.796 9.66-9.579 13.58-2.959-6.92-5.921-13.84-9.694-22.66-3.024 4.06-4.496 6.02-6.731 9.02-2.208-2.21-6.406-5.7-6.079-6.19 4.523-6.92-.766-12.26-2.566-17.99 4.824-1.55 9.431-2.99 15.1-4.79-2.127-4.25-3.708-7.36-5.617-11.07 1.853-.1 3.597-.76 4.17-.19 6.979 6.71 13.74 13.58 20.992 20.83 1.635-.82 4.416-2.23 7.85-3.98-5.234-3.05-10.169-5.91-16.002-9.35 2.152-3.29 3.814-5.78 5.449-8.28-9.296-11.42-23.987-11.07-37.262-13.72.381-1.47.735-2.97 1.143-4.47 4.688-.54 9.377-1.09 14.392-1.63 1.988-10.11-6.216-9.16-11.968-10.39-.764-3.05-1.419-5.72-2.073-8.39 4.596-5.36 4.141-9.36-1.365-11.99-5.651 5.21-12.983 5.53-21.997.95 5.642-1.12 9.676-1.94 14.773-2.94-3.272-5.07-6.108-9.49-9.679-14.97 8.858-2.09 20.2 11.48 24.857-5.61-3.189-1.77-7.823-2.86-9.568-5.75-1.636-2.67-.138-7.22.052-13.19-4.388 3.62-7.767 6.46-12.482 10.35 1.253-5.99 2.152-10.27 3.295-15.67-12.402-.52-23.225-8.78-36.988-1.23 5.67 1.69 9.867 2.95 13.956 4.15 1.146 5.83 2.292 11.5 3.957 19.97-6.598-7.41-16.52-5.45-19.438-15.13.138 8.7.139 16.49 7.173 22.82 3.489 3.16 4.962 8.56 7.28 13 2.89 5.56 5.699 11.15 9.298 18.29-4.551 1.39-9.022 2.75-14.854 4.55 2.972 4.82 5.781 9.32 9.025 14.52-5.341 6-10.465 11.61-9.7 21.48.383 4.74-6.675 10.71-11.363 15.01-4.278 3.9-7.658 7.44-8.911 13.49-.653 3.16-4.714 5.59-7.603 8.75.52 9.95-1.441 19.81-7.027 29.32-2.506 4.25-1.715 10.44-2.722 17.88-1.744 1.09-9.267 1.63-3.597 9.32-5.369 1.99-11.393-.55-13.517 7.74-1.226 4.82-10.22 7.49-15.48 11.44-3.107 2.34-6.595 4.8-8.448 8.07-5.722 10.02-13.053 19.43-13.486 31.8-.082 2.1-1.417 5.01-3.107 6.1-9.212 6.11-18.451 12.29-28.262 17.36-4.088 2.12-8.913 1.49-14.338-.6-6.242-2.43-14.365.13-21.67.24-14.719.21-29.465.62-44.184.12-3.843-.13-8.287-2.5-11.258-5.15-10.278-9.19-24.452-13.71-31.814-26.36-8.559-.65-11.723-8.4-17.066-13.19-4.526-4.04-8.643-8.54-12.296-13.6-8.723-3.17-18.753-4.37-23.798-14.64-.682-1.34-3.107-1.86-4.798-2.62-11.776-5.35-13.303-8.89-8.399-20.99-3.653-.33-7.142-.65-11.776-1.09 1.172-2.86 1.962-4.74 2.997-7.25-10.441-8.21-22.079-5.51-33.908-3.66-3.026-3.95-2.754-8.42 1.225-10.65 2.398-1.37 6.705.21 10.03 1.03 2.563.66 4.907 2.18 8.587 2.05-3.953-5.15-7.935-10.33-12.242-15.89-3.134 2.1-5.887 4.68-9.158 5.83-1.962.71-4.743-.88-7.141-1.42.762-2.34.926-5.29 2.452-6.92 1.58-1.69 4.497-2.1 6.05-2.73-5.697-5.31-10.605-10.44-16.112-14.8-4.689-3.71-8.07-10.74-15.864-6.6-2.51-10.79-4.693-20.38-7.394-31.97-2.644-1.66-7.605-4.71-12.458-7.71 5.749-12.35 3.923-14.72-14.15-18.78-7.446-24.94-18.08-48.93-29.915-72.31-7.576 3.59-10.004-4.34-15.919-7.04 2.397-5.39 6.348-9.56 2.749-16.16-3.108-5.72-2.456-13.46-4.01-20.14-.682-2.97-2.237-7.52-4.281-8.04-9.159-2.45-11.232-10.96-16.14-17.01-5.289-6.49-10.66-12.95-16.794-20.44-1.554 1.06-4.279 2.97-7.495 5.2-.572-1.88-1.718-3.68-1.446-5.2 1.171-6.84-.738-11.8-7.253-14.99-1.799-.88-4.389-3.79-4.035-4.91 3.106-9.21-5.835-11.34-8.807-17.42-1.526 2.07-2.535 3.41-3.843 5.21-5.97-5.97-12.077-11.75-17.72-17.94-1.39-1.5-1.527-4.36-1.828-6.62-1.01-7.93-4.255-14.39-9.49-20.66-4.253-5.07-5.999-12.27-8.998-18.75 3.843-2.43 6.813-4.25 11.337-7.09-3.216-1.2-4.824-2.37-6.269-2.18-5.969.73-8.94-1.09-7.824-7.61 1.797-10.51-.739-14.41-10.47-16.84-1.227-.3-2.345-.93-6.297-2.54 6.705-1.3 10.82-2.09 15.836-3.07 1.415-12.05 3.24-24.18 4.164-36.33.57-7.66 3.895-12.07 11.69-13.38-.274-7.36 2.177-15.21-8.699-17.85-2.017-.49-4.526-8.23-3.245-10.93 3.297-6.79 2.395-16.3 11.526-19.81 1.499-.58 2.344-2.78 3.625-4.39-1.255-4.69-2.456-9.27-4.065-15.24m1146.9 550.01c-.76.22-2.04.25-2.23.71-.38 1.03-.22 2.29-.33 3.65l.03-.03c1.25-.43 2.62-.54 2.7-.95.24-1.06-.08-2.26-.17-3.38m-23.19 10.22c-.03.67-.11 1.34-.13 2.06.85-.21 1.55-.32 2.2-.59.11-.06.08-1.01-.08-1.06-.63-.25-1.34-.3-1.99-.41m-126.13 94.87c-15.78 2.26-8.09 14.85-13.98 22.7 7.23.46 11.61.76 17.72 1.15-1.26-8.02-2.43-15.4-3.74-23.85m171.09-174.55c-.25.79-.52 1.6-.76 2.39 2.03.24 4.06.48 6.11.74-1.79-1.05-3.58-2.11-5.35-3.13m23.45-83.48c0 6.87 1.07 12.89 7.77 14.8.93-.87 1.86-1.69 2.78-2.56-3.51-4.06-7-8.15-10.55-12.24m-266.604 274.75c1.008.19 2.017.44 3.026.63 1.038-4.31 2.068-8.61 3.108-12.92l-3.439-.44c-.898 4.23-1.796 8.51-2.695 12.73m-44.54-9c-11.459 16.19-11.228 17.82 1.975 24.77 4.751-6.76 8.316-1.19 12.667 2.29 4.387-6.13 8.448-11.77 13.162-18.34 1.936 3.41 3.626 6.35 5.316 9.35.981-.49 1.936-.95 2.89-1.47-1.255-3.43-1.611-7.82-3.982-10.08-2.999-2.84-7.006-2.92-11.148.46-3.107 2.56-7.959 3.05-11.992 4.47-1.61-5.16-10.25-2.62-8.888-11.45m-87.89-64.17c3.953 3.57 7.66 6.95 13.985 12.67-.683-9.62 5.53-15.61-1.013-22.1-4.06 2.97-7.876 5.75-12.972 9.43m-22.66-46.2c-.109.05-.081 1 .082 1.06.627.24 1.335.3 2.017.44.027-.69.109-1.37.136-2.1-.872.21-1.608.35-2.235.6m-11.421-2.87c-1.363.38-2.781.49-2.863.9-.218 1.15.055 2.4.165 3.6.79-.25 2.071-.33 2.289-.82.436-1.03.273-2.29.409-3.68m-24.128-24.88c1.118 2.04 2.236 4.03 4.035 7.3 2.208-3.57 3.516-5.7 6.486-10.46-5.315 1.6-7.932 2.37-10.521 3.16m9.914-39.41c-1.743 9.66 2.048 16.05 11.37 19.16-3.762-6.38-6.98-11.78-11.37-19.16m-37.798 39.37c-.109.06-.082 1.01.082 1.07.626.24 1.335.3 2.017.43.027-.68.108-1.36.163-2.12l-.027.02c-.873.22-1.608.36-2.235.6m18.666-27.55c-.545.33-.545 1.53-.79 2.32 1.063.24 2.453 1.04 3.134.63.763-.44.927-1.97 1.744-3.87-1.99.41-3.216.38-4.088.92m-1.912-19.13c-1.799 3.92-3.651 7.85-6.703 14.44 8.913-3.89 9.457-8.42 6.703-14.44m-26.442-15.43c-6.733-.41-6.133 3.57-6.268 7.63 10.386 6.08 20.499 10.09 30.392-1.33l-.028.03c-1.5-3.41-3.109-6.98-4.391-9.9-4.279-.79-7.823-1.44-8.531-1.55-5.151 2.48-8.23 5.28-11.174 5.12m17.658-20.82c-.872.71-1.389 1.83-2.043 2.81 1.145.11 2.371.46 3.461.19.436-.11.6-1.47.872-2.24-.79-.3-1.936-1.06-2.29-.76m-38.671 39.38-.026.02a34 34 0 0 0 1.689-1.09c-1.145-1.91-2.29-3.81-3.435-5.72-.654.38-1.282.79-1.936 1.17zm-10.44-4.89c-2.099.79-3.761.93-4.088 1.64-.463 1.06-.354 2.86.273 3.76.491.65 2.263.41 3.462.57.081-1.66.19-3.29.353-5.97m13.049-39.86c5.371 8.91 6.87 9.59 17.773 8.88-3.653-6.32-8.234-10.84-17.773-8.88m-12.174 23.48c1.469 1.63 2.914 3.28 4.384 4.91.49-.65.953-1.28 1.417-1.96-1.934-.97-3.868-1.99-5.801-2.95m-.166-.04c-2.605-.47-6.017-2.37-5.236 4.05 2.038-1.55 3.627-2.82 5.236-4.05m-14.895-47.19q4.881 13.98 16.166 12.57c-.818-4.14-1.61-8.2-2.838-14.39-2.616 4.47-3.896 6.62-5.586 9.56zm-1.169 16.44c-.191 2.58-.353 5.15-.544 7.74l.028-.03c1.035.05 2.044.08 3.08.13-.137-2.64-.273-5.28-.383-7.9zm15.012-30.99c14.175 4.8 17.31 3.52 27.692-12.37-10.52 4.69-18.152 8.12-27.692 12.37m-10.712-.9c-.136 2.7-.217 5.4-.352 8.09.872.11 1.772.25 2.644.36.545-2.73 1.089-5.45 1.606-8.15h.055zm16.595-26.73c-.245.13.056 2.01.546 2.29.954.51 2.208.41 3.353.57-.028-1.12-.083-2.26-.083-4.06h-.054c-1.663.46-2.835.65-3.762 1.2m-14.747-6.9c-.599 1.96-1.199 3.87-1.798 5.83.572.25 1.199.49 1.772.74l2.834-5.78c-.927-.27-1.881-.52-2.808-.79m-33.716 4.93c-.626 5.31-1.062 9.23-1.66 14.69 7.931-1.34 14.745-2.05 21.205-3.82 1.744-.49 3.434-4.19 3.624-6.51.136-1.66-2.073-4.69-3.681-5.04-2.208-.47-5.288.43-7.114 1.88-1.717 1.39-2.289 4.19-3.515 6.78-3.271-2.94-5.506-4.96-8.859-7.98m25.882-9.62c-.344 1.56-.711 3.13-1.08 4.66h2.181c-.367-1.57-.734-3.09-1.101-4.66m-.044-.14c.002 0 .004-.01.006-.02l-.007-.03zm-.93-10.63c.321 3.47.667 6.92.989 10.38.826-3.43 1.676-6.83 2.501-10.27a100 100 0 0 1-3.49-.11m-19.027-9.86c7.578 1.8 11.612 2.51 12.21-5.4-3.652 1.64-6.378 2.84-12.21 5.4m10.678-39.3c-3.107 5.94-5.041 9.67-7.276 13.98l.028-.03c9.54 2.18 17.473 3.96 25.623 5.84-1.12-10.28-16.383-6.85-18.375-19.79m-43.604 43.38c-.109.05-.081 1.06.082 1.11.627.25 1.39.31 2.072.44-.001-.71-.028-1.39-.055-2.12-.709.16-1.445.29-2.099.57m31.084-84.62c3.6 11.53 14.469 6.72 22.627 11.67-2.592-12.89-13.386-10.01-19.602-14.15-.325-.21-1.961 1.58-3.025 2.48m6.382 21.26c-3.244-6.19-7.087-6.05-12.019-.68 1.39 2.69 2.89 5.61 4.307 8.39zm-39.546 19.15c-.791.25-2.18.33-2.262.68-.245 1.12.027 2.37.109 3.55.791-.25 1.581-.49 2.835-.93l.027.03c-.218-1.09-.464-2.21-.709-3.33m13.624-21.69c-.626 1.06-1.96 2.94-1.771 3.13 1.582 1.48 3.463 2.59 5.235 3.82.681-.95 1.362-1.91 2.043-2.91zm-5.649-40.47c-3.597 7.03-4.958 13.84-1.904 21.04 7.795-.09 13.719 2.82 17.773 8.72 3.115-2.73 6.203-5.39 9.237-8.04-4.996-5.41 4.684-7.15 3.516-10.49-6.654-13.35-17.311-12.29-28.622-11.23m-15.775 38.18c.735 3.45 1.469 6.9 2.367 11.06 3.889-.63 7.344-1.2 10.555-1.69 1.888-9.59-2.42-12.71-12.922-9.37m59.849-45.07c-6.269-1.14-9.322-.71-9.729 8.37 4.169-3.57 6.268-5.4 9.729-8.37m-78.137 53.1c-.136 1.61-.953 3.68-.245 4.77.846 1.39 2.944 2.02 7.033 4.53-2.018-5.18-2.917-7.44-3.817-9.7l-.027.02c-.981.11-1.99.25-2.944.38m78.623-75.88c-5.588 1.17-9.622 2.04-10.329 9.29 5.097-1.72 9.049-2.67 10.329-9.29m-55.406 43.35c-.491.11-.709 1.25-1.063 1.93l3.108 1.2c.081-.79.136-1.61.19-2.37-.736-.3-1.581-.93-2.235-.76m52.648-63.66c.246 1.72.029 3.46.683 3.9.982.6 2.562.22 3.843.25.027-1.23.545-3.06-.055-3.6-.791-.68-2.453-.38-4.497-.57zm-19.565 23.87c.735-.41 1.499-.84 2.207-1.28-1.2-2.01-2.427-4.06-3.627-6.08-.681.41-1.417.82-2.098 1.23 1.173 2.04 2.345 4.09 3.518 6.13m18.038-30.3.027.03c.926-.22 1.854-.44 2.753-.68-.546-3.33-1.064-6.63-1.61-9.95-1.363.33-2.698.68-4.061 1.01zM1157.7 817.787c-.08.083.03 1.008.19 1.063.65.163 1.36.164 2.04.246l-.24-2.045v-.054c-.68.245-1.37.436-1.99.79M667.047 1288.47c-.109 1.15-.464 2.37-.218 3.49.11.44 1.472.6 2.235.87.245-1.17.518-2.31.79-3.46-1.227-.41-2.017-.65-2.807-.9m21.418-24.63c.409.57.791 1.61 1.255 1.63.736.03 1.662-.4 2.207-.95.404-.4.303-1.26.511-2.54-1.805.83-2.862 1.34-3.973 1.86m7.522-8.39c-.109.05-.054 1.03.082 1.11.627.25 1.336.3 2.044.41.054-.69.081-1.37.134-2.12-.86.22-1.613.33-2.26.6m20.302-28.04c-.027.68-.11 1.36-.137 2.1.873-.22 1.582-.33 2.236-.6.109-.06.081-1.01-.082-1.07-.627-.24-1.336-.3-2.017-.43m-49.66 21.63c-6.156 9.64-10.651 16.75-16.179 25.44 3.477 1.79 6.822 3.56 10.762 5.6 1.933-11.04 3.457-19.87 5.417-31.04m61.894-41.34c-1.09 1.75-2.207 3.47-3.297 5.21.436.33.873.65 1.282.95l4.196-4.19c-.709-.66-1.472-1.31-2.181-1.97m-1.422-28.01c.683 7.49-3.296 13.16 2.538 19.27 4.796-6.98 4.932-12.35-2.538-19.27m-34.909 42.53c-3.679 2.48-8.421 5.64-3.541 12.27 4.388-3.35 4.523-11.5 12.4-8.97 1.064.36 4.061-5.26 6.159-8.06-.736-.41-1.5-.79-2.236-1.2-4.306 1.96-8.939 3.38-12.782 5.96m350.148-405.055c.58 2.044 1.12 4.062 1.72 6.079.74-.136 1.47-.273 2.27-.409-.14-1.99-.28-3.979-.41-5.969l-.03-.027c-1.2.109-2.35.217-3.55.326m6.98-9.919c-.16.654-.16 1.363-.22 2.017l2.05-.245.02-.027c-.24-.681-.43-1.363-.79-1.935-.08-.082-1 .027-1.06.19m-39.87 32.398c1.93-.136 3.84-.299 5.75-.408l-.03-.027c0-1.309 0-2.617.06-3.925-2.02.272-3.98.544-6 .816.08 1.172.14 2.372.22 3.544m-25.894 2.666c.218.763.327 2.125.735 2.207 1.064.245 2.263-.027 3.408-.081-.191-.791-.409-1.554-.682-2.753l-.028.028c-1.117.19-2.261.408-3.433.599m-260.259 258.86c.818.87 1.635 1.8 2.453 2.67 1.853-1.85 3.761-3.65 5.45-5.61.164-.17-.871-1.37-1.362-2.07-2.18 1.69-4.388 3.35-6.541 5.01m4.385-16.16c-.109.05-.081 1.06.082 1.12.627.24 1.391.3 2.072.43 0-.71-.028-1.39-.056-2.12-.708.16-1.444.3-2.098.57m206.024-239.253q.73 9.43 9.293 8.046a2224 2224 0 0 1-9.293-8.046m-22.6.027c2.262-1.226 4.552-2.479 6.814-3.705-.491-.927-.928-1.854-1.419-2.78-2.344.98-4.661 1.934-7.004 2.915l-.028-.028zM757.837 987.8c.519 2.644 1.065 5.261 1.61 7.932l2.29-.327c-.246-2.644-.519-5.26-.738-7.876v-.055c-1.035.109-2.126.218-3.162.326m104.65-101.309c.218.872.327 1.581.599 2.235.055.109 1.009.082 1.064-.081.245-.627.299-1.336.435-2.017-.681-.027-1.363-.109-2.098-.137m-98.218 89.864c.218 1.962-.055 3.598.627 4.443.49.599 3.052.6 3.298.082.544-1.035.681-2.861.109-3.761-.436-.708-2.29-.491-4.034-.764m-2.02-10.029c4.852 2.835 10.249 5.07 15.809 1.42 3.897-2.589 6.296-6.894 4.359-14.116-3.569 4.55-5.995 7.629-8.557 10.844-3.788-.464-7.277-.9-10.766-1.337l-.028.028c-.272 1.035-.545 2.125-.817 3.161m37.066-22.941 2.017.001-1.01-4.265zm-1.559-25.428c5.534 6.461 2.564 10.739-1.278 15.18-.405.461 2.489 3.737 3.866 5.705 7.498-11.033 7.367-14.574-2.588-20.885M84.958 1108.98c.654 1.09 1.173 2.21 1.99 3.08.192.19 1.988-.74 1.936-.85a13 13 0 0 0-1.446-3.29c-.083-.09-1.39.57-2.48 1.06m-11.202 3.89c-.245.14.055 2.02.519 2.27.926.49 2.207.4 3.297.57-.027-1.12-.055-2.23-.11-4.02-1.633.45-2.763.62-3.706 1.18",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1111.05 1798.09c6.68-3.79 8.4-1.52 9.49 5.18-3.68-1.99-5.94-3.22-9.49-5.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M1156.1 1742.09c5.51-.82 8.86-1.33 14.23-2.12-4.33 7.22-7.77 7.27-14.23 2.12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1208.7 1690.81c4.09-2.83 6.82-4.69 9.62-6.62.9 1.55 1.83 2.48 1.61 2.97-1.66 4.5-4.5 6.41-11.23 3.65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M1231.7 1673.65v1.3c-1.48-.2-2.99-.42-4.46-.64z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M1226.77 1674.27v.11l.03-.03v-.11c.14.03.29.05.44.07l-.47.07c-.03-.02-.06-.03-.09-.05z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1220.09 1670.43c2.93 1.74 4.77 2.83 6.59 3.9-2.91 1.92-5.48 2.76-6.59-3.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M1135.57 1726.04c2.81 4.11 5.67 6.59 6.36 9.62 1.3 5.72 1.69 11.66 1.74 17.55.03 1.55-2.2 3.68-3.87 4.47-.9.41-3.89-1.23-4.19-2.35-1.83-7.22-3.41-14.52-4.42-21.91-.22-1.63 2.04-3.62 4.36-7.41z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M1087.61 1762.71c1.66 2.43 2.78 3.43 3.02 4.61.61 3.1.77 6.27 1.18 10.05-3.57 1.56-6.82 2.95-10.19 4.42-.11 4.74-.22 9.59-.36 16.27-8.53-6.35-8.72-11.94-4.74-18.21 3.35-5.26 6.78-10.49 11.06-17.11z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M1241.42 1634.05c.64-.21 1.33-.22 2.02-.32-.06.7-.11 1.36-.16 2.06-.68-.19-1.39-.35-2.02-.65-.11-.06 0-1.04.16-1.09"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M1243.5 1633.72c-.02 0-.04.01-.06.01v-.01z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M1053.55 1818.03c.68.13 1.39.19 2.01.43.17.06.22 1.04.09 1.07-.66.27-1.37.38-2.24.6l-.03.02c.06-.76.11-1.41.17-2.12"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M1107.42 1763.18c3.33-13.79 4.91-15.59 15.1-17.06-3.81 5.99-7.38 11.85-11.25 17.52-.33.49-2.51-.27-3.85-.46"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M1065.08 1802.47c.64-.22 1.34-.22 2.01-.3-.05.7-.1 1.34-.16 2.04-.68-.19-1.39-.35-2.02-.65-.1-.06 0-1.04.17-1.09"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M1067.12 1802.17h-.03v-.03z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M1021.83 1837.86c.68.14 1.36.17 1.99.41.16.06.19 1.01.08 1.07-.65.27-1.35.38-2.21.59.03-.72.11-1.39.14-2.07"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M1011.61 1847.73c.7.05 1.39.11 2.06.13-.13.68-.16 1.37-.4 1.99-.06.17-1.01.19-1.07.08-.27-.64-.38-1.34-.59-2.2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M1021.69 1839.93v.03l-.03-.02c.01-.01.02-.01.03-.01"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M1011.61 1847.73h-.03l.02-.03c.01.01.01.02.01.03"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M1097.69 1755.41c-5.12 4.59-6.77.16-9.45-1.77z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M1037.76 1795.81c3.76-6.86 7.44-5.69 11.72-1.85-3.21.49-6.43 1.04-11.72 1.85"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "m1088.24 1753.64-.17-.03v-.09c.06.04.11.08.17.12"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M1088.18 1753.42v.11c-.01-.04-.02-.08-.02-.11z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M1088.07 1753.61v.02l-.03-.02z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M1007.75 1808.86c.77.22 1.53.44 2.26.63-.24.79-.49 1.52-.73 2.31-.76.06-1.53.17-2.29.22.24-1.06.52-2.1.76-3.16"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m1265.75 1554.44-4.36 4.36-1.5-1.49 4.36-4.36z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M972.51 1799.94c.791.25 1.554.47 2.753.85l.028-.03c-.245 1.12-.463 2.26-.708 3.43-.764-.27-2.153-.41-2.235-.81-.246-1.07.081-2.27.162-3.44"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M949.065 1810.19c.736-.14 1.472-.27 2.235-.38.545 2.01 1.091 4.03 1.636 6.05-1.172.08-2.316.19-3.488.27h-.055c-.11-1.96-.219-3.98-.328-5.94"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M923.963 1788.79c1.471-1.2 3.597-1.53 7.113-2.81-.736 3.14-.599 5.18-1.525 5.94-1.117.96-3.163.88-4.771 1.23-.327-1.53-1.362-3.92-.817-4.36"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M925.78 1766.3c.654.38 1.335.74 2.371 1.34-.681 1.01-1.226 2.1-2.044 2.91-.136.14-1.934-.89-1.908-1.03.354-1.12 1.008-2.15 1.581-3.22"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M917.168 1751.8c.163-5.28-.683-10.38 6.049-10.19 1.608.03 4.553 3.74 4.418 5.62-.49 7.14-5.56 4.85-10.439 4.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M890.62 1768.26c.573 3.14 1.118 6.3 1.664 9.4-.927.22-1.827.47-2.753.68l-2.536-9.34z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M879.172 1773c.218-.49 1.472-.54 2.262-.79.082 1.17.355 2.42.138 3.57-.082.35-1.473.49-2.808.84.108-1.36-.028-2.59.408-3.62"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M871.456 1761.63c4.824-1.39 9.649-2.72 15.645-4.46-2.161 6.59-7.376 8.08-15.645 4.46"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M1611.05 1020.36c-1.82-2.85-2.81-5.43 3.82-6.56-1.69 2.92-2.74 4.74-3.82 6.56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M866.245 1740.51c.79.08 1.799-.11 2.235.33.49.49.491 1.47.709 2.23h.054c-.763.22-1.499.41-2.289.6-.246-1.06-.464-2.1-.709-3.16"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M835.503 1750.92c2.208 3.35 4.144 6.27 7.825 11.75-6.978.1-10.958.16-17.827.26l-.027-.02c4.633-5.56 6.731-8.1 10.029-11.99"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M1593.49 997.225c.44-.654 2.27-.408 4.01-.625l.03.026c-.25 1.935 0 3.544-.71 4.364-.46.57-3 .49-3.3-.03-.54-1.037-.62-2.809-.03-3.735"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M808.95 1756.58c-4.742 5.18-7.031 7.68-10.738 11.77h-.053c-3.081-3.62-5.263-6.13-9.652-11.28 7.713-.19 12.456-.3 20.443-.49"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M834.759 1707.34c-.218-.05-.219-4.14.462-4.39 1.772-.73 4.17-.84 5.942-.21.954.35 1.172 2.8 2.209 5.64l.027.02c-3.843-.35-6.296-.46-8.64-1.06"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M815.106 1721.86c1.334-6.08 5.859-6.89 12.974-5.67-3.243 4.61-5.669 8.07-9.211 13.08-1.854-3.49-4.145-5.72-3.763-7.41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M846.939 1679.46c.654-.22 1.362-.22 2.016-.33l.028.03c-.055.65-.109 1.36-.163 2.02-.681-.19-1.39-.36-2.017-.66-.109-.05-.028-1.01.136-1.06"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M798.7 1709.82c3.024-2.43 6.08-4.83 9.671-7.72 5.671 6.92 6.544 12.1-1.223 17.69-2.897-3.39-5.66-6.69-8.448-9.97"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    fillRule: "evenodd",
    d: "M707.311 1591.09c2.13 10.45 11.085 1.64 15.508 5.09 1.009 3.46 1.909 6.65 3 10.35 2.941-3.85 5.106-6.72 7.264-9.58.914 1.77 1.858 3.57 3.12 5.96 2.125-2.61 3.461-4.33 4.851-6.05.436 2.29 1.5 4.66 1.173 6.84-1.388 10.39 1.884 16.27 11.398 22.95 10.332 7.23 17.448 20.06 11.182 34.67q17.201 6.195 25.867-1.44c-3.298-1.72-6.27-3.22-9.296-4.77 4.551-8.04 14.256-1.33 17.148 10.99.518 2.26 1.091 4.52 1.882 7.93 11.829-2.51 9.898 15.45 23.662 13.52-2.016 5.51-3.488 9.43-5.722 15.53l-11.259-11.25c-7.006-6.9-9.377-6.38-14.554 3.1-4.989-2.81-10.032-5.62-15.512-8.7.872-2.07 1.716-4.17 2.643-6.35-.736-.13-1.798-.65-2.098-.35-2.235 2.02-4.661 3.95-6.269 6.43-1.144 1.74-.299 5.48-1.58 6.27-6.977 4.19-4.905 10.08-4.113 16.1.437 3.44-.462 7.06-2.996 11.07-2.318-7.12-4.636-14.17-7.554-23.03 1.172-2.05 3.624-6.24 6.594-11.39-3.789-1.23-6.243-1.99-9.432-3-.272 3.38-.435 5.83-.679 9.07a875 875 0 0 1-9.896-3.3c.681-3.62 1.254-6.7 2.016-10.63-5.752-3.08-11.614-6.27-17.993-9.7.654-3.38 1.336-6.95 2.098-10.93 2.562-.44 5.151-.84 7.959-1.31-2.509-5.88-4.8-11.33-7.118-16.7-4.716-.36-9.377.16-13.193-1.42-1.69-.71-1.582-5.67-2.564-9.76-9.594 4.47-17.199-.63-25.296-6.06 1.798-4.68 3.024-9.23 5.313-13.16.728-1.27 4.23-.93 6.521-1.3zm36.807 66.49c-2.424 6.13-2.996 10.58 2.483 14.58l11.691-11.69c-6.214-1.25-10.003-2.04-14.174-2.89m10.247-8.33c-.136-.03-.735.73-.654.87.355.63.873 1.09 1.336 1.66.436-.54.872-1.14 1.281-1.72-.654-.27-1.308-.65-1.963-.81m-54.949-42.41c-3.16 4.53-4.892 9.44-.252 13.75 5.588 5.21 9.812-1.14 14.063-3.32 10.361 13.36 20.42 17.75 34.974 13.71-8.123-3.54-14.148-6.18-20.717-9.05 1.771-2.75 3.434-5.39 6.159-9.7-13.311 1.22-24.936 3.91-34.227-5.39",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M769.669 1725.37c5.642-2.64 5.667-13.25 15.099-9.54l-.027-.08c.012.02.024.05.036.07.012-.02.026-.03.04-.05l.007.01-.046.04c2.251 4.37 4.531 8.76 7.053 13.67-8.367 4.77-14.366-3.96-22.162-4.12"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M785.505 1714.66c-1.837-9.21 2.242-14.4 12.236-15.56.325 3.57.595 7.13.893 10.67-1.523 3.21-3.075 6.45-5.251 11.13-2.897-1.76-5.74-3.46-8.557-5.14.285-.37.755-.77.679-1.1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "m798.643 1709.76.057.06c-.028.03-.057.05-.085.07l.027-.03-.008-.09c.002 0 .006-.01.009-.01"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M759.887 1730.35c2.726 1.15 5.452 2.35 9.377 4.04-2.18 1.9-4.797 4.52-5.042 4.33-2.235-1.91-4.116-4.28-6.079-6.51.6-.6 1.144-1.26 1.744-1.86"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M784.826 1715.76c-.003 0-.006 0-.009.01l-.048-.05c.02.01.038.02.057.04"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M804.054 1634.84c2.071.38 4.47.22 6.133 1.28 1.39.9 1.909 3.16 3.572 6.19l-.027-.03c-6.542-.82-8.587-1.06-10.685-1.31.354-2.04.653-4.09 1.007-6.13"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M724.035 1690.31c1.935.79 3.434.98 3.87 1.74.382.71-.381 2.08-.626 3.14-.79-.25-1.989-.25-2.316-.79-.546-.87-.547-2.13-.928-4.09"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M695.574 1679.35c.273-.44 2.127-.49 2.208-.24.437.98.518 2.15.818 3.87l.027.02c-1.799-.16-2.889-.27-4.006-.41.299-1.11.381-2.34.953-3.24"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M708.654 1641.47c10.958 4.47 8.559 7.3 1.527 11.45-.518-4.01-.9-6.79-1.527-11.45"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "m741.436 1596.81-.082-.03.052-.06z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M733.531 1596.81h-.109l.036-.09z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "m733.149 1596.86-.066.09-.043-.09z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M707.744 1590.86h-.109c.023-.03.045-.07.068-.1.013.04.028.07.041.1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "m707.39 1590.94-.079.15-.03-.15z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M680.543 1594.56c2.072.11 4.143.22 6.188.3 0 1.42 0 2.83.028 4.22-2.045.03-4.143.06-6.188.08-.027-1.53-.002-3.07-.028-4.6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "m698.338 1585.71-.027.02h-.005c.011-.01.021-.02.032-.02"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M692.915 1589.17c-4.334-.79-2.154-2.76-.001-4.09 1.118-.68 2.426-1.01 3.625-1.5l1.767 2.15c-1.818 1.23-3.847 3.68-5.391 3.44"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M682.793 1538.44c.681.14 1.362.17 1.989.41.164.06.191 1.01.082 1.07-.653.27-1.361.38-2.204.57.051-.69.08-1.36.133-2.05"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "m682.66 1540.49-.003.05v-.05z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "m673.88 1540.87-.027.03-.006-.04c.011 0 .022 0 .033.01"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M656.68 1535.88c2.943-5.67 7.604-5.59 12.811-3.71 2.284.8 3.735 3.7 4.356 8.69-5.821-1.69-11.29-3.29-17.167-4.98"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M663.868 1506.06c9.785 2.43 5.344 8.51 8.288 11.56-1.008.41-1.989.79-2.971 1.23v-.06c-1.5-3.62-3.027-7.28-5.317-12.73"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M654.572 1475.35c.654-.28 1.364-.38 2.236-.6-.027.73-.11 1.41-.137 2.1-.681-.14-1.39-.2-2.017-.44-.163-.06-.218-1.04-.082-1.06"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    fillRule: "evenodd",
    d: "M781.252 5.528c9.486 5.344 16.137.766 24.885-5.528-1.416 8.557-2.342 14.226-3.458 20.848 2.671.328 5.316 1.227 7.851.928 5.942-.762 8.777 1.038 13.33 6.136 10.387 11.693 21.592 23.713 40.726 22.027 6.951-.625 15.646 3.765 21.426 8.454 8.042 6.57 18.183 10.877 23.282 21.207 4.69 9.54 10.062 19.161 16.987 27.121 4.743 5.451 12.539 8.396 19.272 11.859 2.726 1.417 6.352.955 9.459 1.718 8.369 2.1 11.04 5.481 11.751 14.093.901 10.711 5.211 20.141 10.282 28.427-4.497 3.951-8.913 7.82-13.791 12.098 1.936 4.279 3.628 7.986 5.155 11.421 1.526.163 2.726.654 3.189.245 2.698-2.37 4.523-5.721 9.266-2.668 7.169 4.607 9.84-.625 11.23-4.958 9.406.356 18.206.711 28.816 1.122-5.67 8.23-11.23 11.009-19.52 8.99-7.769-1.882-9.757 2.451-8.829 10.246 9.269.274 18.069.521 28.979.85.43.818 2.04 3.898 4.06 7.769 12.07-3.841 18.4 9.024 31.24 9.871-2.81-4.498-5.24-8.45-8.43-13.547 1.86-1.525 4.42-3.705 8.01-6.702 2.32 4.77 3.96 8.204 5.89 12.21 1.64-1.308 3.25-1.88 3.52-2.861.87-3.107 1.25-6.322 2.02-10.519 10.16 1.937 20.06 3.874 31.04 5.975-3.54 3.106-7.3 6.43-11.55 10.19 9.34 1.928 16.06-.47 20.17-7.191 5.69 2.045 11.53 4.172 18.42 6.653-3.78 6.786-6.97 12.481-10.49 18.776 13.28 1.61 13.71 1.501 27.45-4.655.9 3.734.77 8.285 3.03 10.766 1.14 1.253 6.43-1.144 10.79-2.124-.84 2.425-1.69 4.415-2.26 6.514-.57 2.098-.84 4.278-1.72 8.747 4.06-3.024 6.25-4.605 9.19-6.784.11 2.998.14 4.715.22 6.649 9.37-.652 4.71-17.305 17.09-14.468-1.18 3.297-3.46 6.731-3.3 10.002.16 3.325 2.78 6.487 4.69 10.52-4.66-.191-8.31-.355-13.49-.629q7.065 6.024 16.38 5.863c.9-3.515 1.91-7.249 2.75-10.437 7.31 2.454 14.34 4.853 22.82 7.717.16 2.998.46 8.04.74 12.891 4.03 2.617 8.39 4.471 11.45 7.633 4.88 5.042-1.83 7.221-4.96 11.009 10.49 3.79 25.89-4.41 28.13 11.833 7.17 1.119 14.94.44 20.41 3.684 5.84 3.435 9.47 10.549 13.39 15.291-1.61 4.225-5.18 9.811-4 11.093 5.42 5.915 11.64 11.639 20.88 12.05-.27 2.289-.63 4.987-1.14 9.047 3.07-1.06 5.38-1.85 7.7-2.638 0 .006.01.012.01.018q4.59-7.072 15.24-1.572c-5.31.564-10.27 1.102-15.2 1.614 6.95 8.922 18.13 4.777 29.18 7.736l-10.68 10.682c4.79 2.508 11.17-5.449 14.96 3.136-2.21 3.079-4.49 6.295-7.27 10.219 9.95 8.205 12.18 23.414 27.29 25.597-.01.035-.01.069-.01.104l-.08-.077-.05.109.13.017q-.405 7.856 7.53 7.479l-7.47-7.472c5.55.703 11.12 1.46 18.24 2.378-2.1 3.569-3.08 5.423-4.26 7.194-1.22 1.88-2.64 3.679-3.78 5.259 5.18 10.031 15.72-4.603 21.01 6.245-3.54 1.089-6.78 2.043-10.76 3.241 1.8 7.468 3.6 14.936 5.53 23.03 2.76.355 5.78.711 9.3 1.12-1.03 2.235-1.77 3.843-1.96 4.306 4.71 3.571 8.7 7.986 13.68 9.977 4.56 1.827 4.8 4.416 5.57 8.231.92 4.634 3.1 8.995 5.23 14.774-4.68 8.883-2.53 15.942 9.87 24.148-4.44.844-7.74 1.415-11.85 2.205-2.21 4.823-2.13 10.355 2.78 13.136 7.2 4.09 5.29 10.031 4.91 16.572 3.65 1.036 7.11 1.991 10.17 2.864-.19 4.224-.33 8.23-.55 12.754-2.18.926-5.42 2.37-7.82 3.405 1.48 10.738 2.79 20.604 4.15 30.416.19 1.39.27 3.162 1.15 3.979 8.58 7.878 3.84 15.835.6 24.038-3.05 7.739-6.07 15.179-3.07 24.228 3.02 9.185-5.54 12.291-11.64 15.342.38 22.511-5.07 27.524-23.74 21.334-.24 8.095-2.15 13.763-12.72 12.29-4.31-.601-9.44 4.903-14.53 7.873.63 4.115 1.15 7.632 1.88 12.456-7.33.788-14.39 1.578-22.73 2.448-1.8 9.756-12.13 9.564-20.41 12.615-6.84 2.533-13.69 5.066-20.36 8.09-3.79 1.716-23.15 2.584-27.42.649-3.25-1.445-6.57-2.645-10.85-4.363-.79 4.388-1.34 7.385-1.94 10.656-1.28.19-2.64.681-3.95.571-4.03-.328-8.53-2.264-11.99-1.092-8.02 2.723-13.52.433-17.48-6.027q-21.72 4.275-27.66-7.499c-5.62 7.902-13.8-7.034-19.49 4.493-1.06-.518-2.13-1.036-3.19-1.609 1.58-3.979 3.13-7.93 4.66-11.745-10.96-.547-18.7-1.203-26.39-1.259-10.19-.057-12.21-1.529-13.79-11.177-.22-1.253-.96-2.426-1.67-4.116-7 2.425-13.7 4.767-21.25 7.355-.01-9.974 8.69-6.893 12.18-11.744-13.52-7.143-26.91-14.259-40.54-21.456.68-1.663 1.47-3.652 2.75-6.895-4.34.242-7.83.431-11.37.619-4.47-5.233-8.01-12.043-13.62-15.423-10.04-5.997-13.96-14.446-15.27-25.13-.17-1.308-.99-2.508-2.02-4.961-4.06 2.425-7.8 4.633-12.81 7.629.33-3.324.54-5.723.71-7.086-4.04-1.091-9.3-.901-11.75-3.409-5.29-5.452-1.37-11.12 2.01-18.205-6.4.571-12.78 1.115-18.48 1.632 1.23-5.859 2.48-11.801 4.03-19.132-8.8.462-15.099-1.474-20.634-7.28-5.507-5.834-7.088-11.502-3.9-17.961-8.206-3.79-15.512-7.171-23.854-11.042 2.753-3.352 4.96-6.049 7.576-9.21-8.07-9.486-15.921-18.754-24.1-28.349 1.853-2.834 3.951-6.077 6.948-10.601-4.77-.9-8.15-1.5-12.484-2.291-4.2-9.103-7.091-21.095-23.145-18.4 2.425-4.878 4.441-8.421 5.967-12.182 2.724-6.704 1.034-12.318-5.645-14.472-10.576-3.382-13.795-11.777-15.514-20.961-1.528-8.231-5.481-15.999-1.776-25.428 1.389-3.516-4.772-10.275-7.935-15.291-7.116-11.202-9.463-25.43-19.577-31.946-1.037-8.83-.411-16.379-3.111-22.511-3.245-7.278-.63-13.327-.277-20.058.272-5.015 8.885-7.413 3.214-14.173-2.454-2.944-1.147-8.775-2.565-12.918-2.945-8.558 4.142-8.611 8.775-10.79-.955-4.552-1.855-8.831-2.756-13.11 6.134 4.879 11.151 10.167 17.99.875-.545-3.107-1.2-6.704-1.936-10.82-2.099.518-3.953.953-5.861 1.444 2.833-8.067 5.286-9.429 10.766-5.585 5.097 3.571 9.868 7.633 14.938 11.231 1.391.954 3.463.955 5.589 1.5 3.214-12.427-11.096-12.621-13.742-21.642 1.989-1.608 4.197-3.378 7.904-6.375-11.613-6.38-22.517-12.16-33.23-18.349-2.181-1.254-5.099-4.225-4.881-6.078 1.306-11.338-4.8-13.9-16.166-12.24.407-6.732.788-12.4 1.169-18.941-4.526-4.961-11.723-9.487-10.198-18.916.272-1.581-2.127-3.816-3.626-5.424-8.751-9.296-17.339-18.645-26.854-27.341-9.569-8.75-16.85-22.406-18.297-36.768-.874-8.613.351-17.415.513-26.136.054-2.726.135-5.588-.628-8.15-4.037-13.137-8.346-26.22-12.737-39.71 2.97-3.734 6.022-7.549 9.456-11.854-7.578-.547-14.665-.166-16.684-11.395m467.898 729.805c.22.763.33 2.126.71 2.235 1.07.245 2.27-.027 3.41-.082-.19-.79-.38-1.526-.68-2.752-1.12.19-2.26.408-3.44.599m146.39-225.469c4.09 1.963 8.2 3.899 13.03 6.216-.63-9.893-7.14-7.905-13.03-6.216m-2.87-21.231c-.05.818-.35 1.772-.02 2.426.27.545 1.22.79 1.88 1.172v-.055c.24-.735.92-1.852.65-2.179-.57-.682-1.64-.928-2.51-1.364m-28.41-55.82c-.03.67-.11 1.341-.14 2.064.86-.214 1.56-.324 2.21-.593.11-.056.08-1.007-.08-1.063-.63-.245-1.34-.299-1.99-.408m-39.42-42.797c-.41.136-.41 1.39-.6 2.126l3.16.71c-.05-.818-.14-1.609-.19-2.427-.79-.191-1.69-.654-2.37-.409m-393.333 89.961c.217.976.407 1.978.624 2.954 1.636.055 3.598.709 4.852.055 1.471-.763 2.316-2.697 3.433-4.087-.436-.545-.845-1.063-1.281-1.608-2.524.895-5.103 1.79-7.628 2.686m142.993-272.58c-.25.136-.03 1.989.41 2.262.92.545 2.18.546 3.3.737.02-1.118.05-2.235.13-4.061l-.03.027c-1.71.408-2.86.517-3.81 1.035m-153.535 38.534c.055 1.417-.163 2.671.246 3.734.164.491 1.472.545 2.289.818.109-1.145.436-2.398.217-3.488-.109-.436-1.471-.6-2.752-1.064M803.58 26.817c-5.914 4.986-6.704 8.066-.788 13.545.299-5.096.462-8.204.788-13.545",
    clipRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M1268.66 812.819c.98.055 1.94.137 2.92.192-.14 2.752-.27 5.505-.41 8.257-1.25-.109-2.54-.191-3.76-.273.43-2.725.81-5.45 1.25-8.176"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M643.086 1419.45c.682.13 1.417.16 2.071.43.164.06.191 1.06.082 1.12-.654.27-1.389.41-2.261.63l-.028-.03c.055-.76.082-1.45.136-2.15"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M1253.07 796.246c4.06-1.661 6.78-2.751 10.35-4.195q-1.905 7.686-10.35 4.195"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M1218.48 814.203c2.31 2.626 6.2 5.252 0 7.876.03-2.669.03-5.259 0-7.876"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M1218.48 822.079v.079l-.05-.055c.02-.007.03-.016.05-.024"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M1232.92 800.141c2.48-1.771 4.99-3.515 7.47-5.286.55.817 1.09 1.69 1.64 2.508l-7.74 4.85c-.47-.682-.93-1.364-1.37-2.072"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M1222.24 809.404c.6.709 1.2 1.363 1.8 2.071-1.82.912-3.67 1.797-5.47 2.681z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "m1218.57 814.156-.04.044-.02.027-.03-.028z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M1218.48 814.199v.004l-.03-.031z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M620.865 1390.64c.272-.82.272-2.08.817-2.35.945-.51 2.157-.44 4.166-.72-.868 1.9-1.114 3.39-1.903 3.86-.655.38-2.045-.47-3.08-.79"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M625.906 1387.56a.1.1 0 0 0-.058.01c.002-.01.003-.01.004-.01z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M1182.72 801.548c3.61.346 6.21 2.563 7.79 6.651-2.59-2.208-5.2-4.443-7.79-6.651"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M1181 812.205c-.04.02-.08.04-.13.06.01-.02.02-.04.02-.06z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M1180.89 812.203h-.11c0-.032 0-.063-.01-.094z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M1173.39 806.233q6.825-1.352 7.38 5.876c-2.22-1.795-4.51-3.599-7.38-5.876"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M630.012 1340.38c1.39-1.39 2.753-2.86 4.252-4.08.164-.17 1.254.76 1.935 1.17-1.172 1.77-2.343 3.59-3.514 5.37-.873-.82-1.8-1.64-2.673-2.46"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "m639.906 1321.33-.001.06c-.008-.02-.016-.03-.024-.05.008 0 .016 0 .025-.01"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M621.015 1313.13c3.543-2.02 7.44-4.23 11.637-6.57 2.907 5.95 5.056 10.38 7.229 14.78-1.686.33-3.825 1.43-5.018.78-4.28-2.31-8.233-5.29-13.848-8.99"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M602.971 1336.73c.599-.33 1.308-.55 1.935-.8l.028.03.245 2.05c-.654-.06-1.363-.06-2.017-.22-.163-.06-.3-.95-.191-1.06"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M625.203 1278.79c.681.13 1.363.16 1.99.41.163.05.19 1.01.081 1.06-.646.27-1.346.38-2.205.59.053-.7.107-1.39.134-2.06"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "m625.069 1280.85-.002.04-.028-.03c.01 0 .02-.01.03-.01"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M630.81 1243.65c-.598 2.61-1.222 5.19-1.819 7.8-.927-.16-1.908-.32-2.835-.49.354-2.7.734-5.42 1.088-8.12z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M630.842 1243.66c-.01 0-.021-.01-.032-.01.002 0 .004-.01.005-.02z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M641.902 1219.24c.845.25 1.69.49 2.508.76-.953 3.14-1.934 6.25-2.888 9.38l-2.752-.68.026-.03c1.035-3.16 2.098-6.29 3.106-9.43"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M671.581 1170.76c8.331-4.13 8.908 7.01 17.11 6.11-10.357 6.76-10.847 6.7-14.229 0-.996-2.02-1.939-4.09-2.881-6.11"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M1399.32 457.677c.49-.382 1.5-.081 2.4-.054-.03.736.11 2.07-.11 2.125-.98.273-2.05.136-3.11.163.25-.79.27-1.798.82-2.234"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M667.595 1190.49v.11c-.011-.03-.023-.06-.034-.1.012 0 .023 0 .034-.01"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M663.596 1178.63c-1.876-7.84-1.365-8.3 7.847-7.84l-7.827 7.82.052.06c-.019 0-.04.01-.059.02l.009.03-.007-.01c1.317 3.95 2.633 7.85 3.95 11.79-7.391 2.16-11.039-2.74-14.986-7.88 3.815-1.38 7.415-2.66 11.014-3.93l-.026-.02.024-.03h-.001z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M647.728 1187.79c3.08 2.21 6.161 4.42 11.095 7.94-9.376 2.34-8.478-4.88-11.095-7.94"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M624.783 1219.84c.6-.33 1.308-.55 1.935-.79l.246 2.04c-.654-.05-1.363-.05-2.017-.22-.164-.05-.3-.95-.164-1.03"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M631.783 1199.05a2502 2502 0 0 0 3.383 12.05c-3.926-2.66-5.053-6.67-3.383-12.05"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M671.546 1170.68h.002l-.001.01c.011.02.022.05.034.07h-.009l-.024.03h-.105l.102-.1v-.01z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M1389.45 437.069c1.8-.054 2.91-.081 4.03-.108-.16 1.145-.08 2.371-.6 3.325-.24.463-2.12.763-2.26.517-.54-.926-.74-2.099-1.2-3.761z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M668.955 1151.79c1.145.28 2.317.52 4.389 1.01l.027-.02c-.681 1.88-.899 3.57-1.853 4.68-.49.55-2.235 0-3.407-.08.272-1.85.572-3.73.844-5.59"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M628.889 1177.13c1.199-.05 2.425-.35 3.543-.1.354.08.436 1.47.682 2.26-1.118.24-2.262.46-3.352.68a88 88 0 0 1-.873-2.84"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M1081.95 698.836c-.24 1.118-.51 2.262-.78 3.407-.77-.273-2.13-.437-2.21-.846-.22-1.09.11-2.289.21-3.434.79.246 1.59.492 2.78.873"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M659.764 1112.63c.218-.49 2.289-.16 4.524-.22-.681 2.32-.844 4.12-1.716 5.42-.3.47-3.352-.13-3.38-.38-.137-1.61-.055-3.38.572-4.82"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bb)",
    d: "M689.138 1080.53c1.47-5.67 4.987-5.75 11.257-1.5l.027.03c-3.706 2.45-6.541 4.36-9.403 6.24-.681-1.61-2.208-3.41-1.881-4.77"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc)",
    d: "M642.318 1127.02c.669-.51 1.339-1.02 2.034-1.5l4.018 5.48c-.654.49-1.308.98-1.935 1.44-1.363-1.8-2.754-3.62-4.117-5.42"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bd)",
    d: "M648.453 1120.56c.654-.28 1.363-.38 2.235-.6-.027.73-.108 1.41-.136 2.1-.681-.14-1.39-.19-2.017-.44-.164-.05-.218-1.04-.082-1.06"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#be)",
    d: "m644.389 1125.49-.037.03-.018-.03z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bf)",
    d: "M718.241 1026.47c-3.599-5.62.352-13.77 11.744-20.63-1.714 5.36-2.776 8.71-4.082 12.79 2.527 1.17 5.326 2.45 8.692 4.02-.436 2.89-.898 5.92-1.279 8.48-4.279 2.48-12.294-.36-15.075-4.66"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bg)",
    d: "M1077.62 681.095c.54-.648 1.36-1.076 2.07-1.609.21.879.78 1.934.49 2.536-.9 1.717-2.18 3.216-3.32 4.796-.71-.544-2.07-1.47-1.99-1.608a23 23 0 0 1 2.75-4.115"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bh)",
    d: "m1355.26 407.952-.06-.007v-.049z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bi)",
    d: "M651.579 1100.04c4.444 8.64-.215 11.34-3.84 14.47-.954-.57-1.936-1.12-2.89-1.69 1.962-3.71 3.897-7.39 6.73-12.78"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bj)",
    d: "M223.125 1534.16c.054-.16.981-.33 1.063-.19.327.6.546 1.31.764 1.96-.682.08-1.364.17-2.045.25.082-.68.027-1.39.218-2.02"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bk)",
    d: "M655.18 1092.57c2.344-1.58 3.598-3.16 5.042-3.3 5.587-.57 6.078 2.32 3.054 8.34-2.781-1.74-4.907-3.05-8.096-5.04"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bl)",
    d: "M1079.69 679.406h.11c-.04.027-.07.053-.11.08l-.03-.107z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bm)",
    d: "M1079.76 679.261c0 .002.01.003.01.005l-.11.001z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bn)",
    d: "M674.305 1062.38c1.092 5.61 1.884 9.62 2.866 14.74-7.887-3.23-8.843-8.15-2.866-14.74"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bo)",
    d: "M660.001 1081.1c1.717-.63 3.434-1.8 5.097-1.72 1.39.08 2.645 1.67 4.008 2.59-.218.6-.382 1.2-.6 1.8l.027.03c-2.726-.17-5.397-.33-8.123-.49z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bp)",
    d: "M682.592 1062.82c.682.13 1.391.19 2.018.43.163.06.218 1.03.082 1.06-.654.28-1.363.39-2.236.6.027-.73.109-1.41.136-2.09"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bq)",
    d: "M864.469 848.745c.763.054 1.445.082 2.126.164-.136.681-.191 1.39-.408 2.044-.055.163-1.036.218-1.118.081-.273-.654-.382-1.362-.627-2.262z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#br)",
    d: "M797.804 881.818c5.316 4.279 10.931 8.75 16.765 13.439-5.232 5.667-16.791-5.29-19.459 10.352-1.064-1.771-2.127-3.543-3.218-5.287l.028-.028c2.124-6.649 4.223-13.271 5.884-18.476"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bs)",
    d: "M761.07 926.615c2.726.382 4.389.465 5.888.983.245.081.164 2.834-.408 3.133-1.036.545-2.753.572-3.843.082-.709-.328-.846-1.991-1.691-4.198z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bt)",
    d: "M737.226 948.278c.055-.379 1.451-.489 2.804-.864-.104 1.349.001 2.59-.405 3.59-.218.49-1.472.545-2.262.844-.109-1.199-.382-2.453-.137-3.57"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bu)",
    d: "m740.06 947.406-.03.008.003-.035z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bv)",
    d: "M787.311 890.783c.273-.763.436-2.125.872-2.18 1.063-.245 2.263.082 3.408.191-.245.79-.518 1.554-.9 2.753-1.117-.246-2.235-.491-3.38-.764"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bw)",
    d: "M1301.69 350.358c-.01.001-.01.002-.01.004-.02-.02-.03-.039-.05-.058z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bx)",
    fillRule: "evenodd",
    d: "M205.667 183.82c2.48 2.154 4.961 4.362 8.014 7.033l7.058-7.057c4.553 1.554 8.369 2.809 13.003 4.391.708-3.979 1.253-6.977 1.743-9.703 15.672-.351 30.474 4.803 46.337 1.808 10.085-1.906 21.126 1.34 31.729 2.132 9.24.683 17.144-1.332 21.258-10.843 1.553-3.624 3.434-6.213 8.476-4.768 1.827.518 4.58-2.234 7.932-4.004 1.173 3.461 2.073 6.868 3.518 10.002 3.082 6.841 6.189 7.333 12.648 3.273 3.38-2.125 7.304-4.087 11.175-4.577 6.405-.789 10.193-3.54 10.519-10.408 9.704.057 19.517 5.399 27.147-5.664 4.335 8.204 7.935 15.018 11.67 22.078 9.295-1.116 10.276-2.751 5.123-9.756-1.581-2.126-3.735-4.225-4.253-6.651-1.419-6.595 1.769-10.111 8.393-9.101 5.479.846 10.767 2.701 16.955 4.31.301 4.66.52 9.129.821 13.899 13.385 10.549 18.479-8.718 30.308-8.171 4.935 6.788 16.274 9.134 16.931 21.071.054 1.035 4.253 1.854 8.75.901a6124 6124 0 0 1-10.089-20.061 3145 3145 0 0 0 20.061-4.956q5.589 10.602 25.815 15.893c2.398-4.305 4.905-8.72 7.629-13.625 1.583 6.432 1.284 12.892 4.364 15.918 4.908 4.852 11.75 9.023 18.374 10.305 3.816.763 8.858-4.714 14.609-8.119 1.09.981 3.244 2.917 5.807 5.207a658 658 0 0 0 6.758-4.25c4.417 5.451 8.452 10.412 12.215 15.046-1.035 5.45-2.015 10.683-3.322 17.55 5.15-3.732 8.584-6.185 12.563-9.073 2.045 4.933 3.082 9.077 5.317 12.402 1.609 2.371 4.799 5.015 7.389 5.097 16.927.576 27.586 10.962 36.938 23.091 6.898 8.913 6.462 9.241 17.229 10.905 2.563 5.56 5.072 10.957 8.016 17.28 4.47-1.852 8.068-3.323 11.883-4.903.439 12.1 8.863 18.289 17.668 25.567 1.88-3.351 3.27-5.832 5.014-8.938 1.363 2.126 2.835 3.435 2.644 4.389-2.151 10.764 7.39 15.889 11.481 23.575.981 1.799 5.125 3.599 7.005 2.973 5.588-1.88 8.969 1.882 10.305 5.016 8.781 20.388 27.672 31.266 42.34 46.64-1.009 1.826-2.263 4.115-3.925 7.085 4.389 3.407 10.305 4.526 10.17 12.729-.08 4.116 8.424 8.369 13.713 13.166-1.09 1.363-2.862 3.625-4.606 5.805 5.453 5.887 9.35.41 12.648-.816 2.455 8.122 4.827 16.053 7.227 24.012 17.828 5.781 20.036 9.951 12.326 25.239 15.018-1.441 15.048 14.448 24.153 20.118-6.512 8.802 6.789 12.347 5.347 19.242-1.716 8.093 5.426 12.401 6.654 19.079.246 1.335 1.99 3.025 1.609 3.734-7.302 13.08 6.792 27.827-3.154 40.607 2.347 16.407-2.065 33.576 6.06 49.275.409.791.9 2.1.546 2.618-5.286 8.229 1.448 18.996-5.773 26.925-1.744 1.907-3.625 5.587-2.943 7.576 4.227 12.183-3.321 22.456-4.655 33.657-.653 5.56-2.778 8.612-9.62 6.512-.435 6.213-.816 11.719-1.142 16.624-7.495 4.278-14.772 8.392-22.512 12.806 2.073 5.015 3.6 8.721 5.345 12.973-5.751 2.207-11.229 4.74-16.926 6.293-3.597.98-7.359.38-8.012 5.721-.163 1.308-3.379 2.943-5.342 3.16-4.388.463-9.486-2.073-12.238 3.786-.245.518-1.962 1.036-2.398.709-11.723-8.342-19.08 3.322-28.347 6.154-5.396 1.634-10.711 3.459-16.298 5.284-.846-2.59-1.719-5.151-2.755-8.367-8.777 2.778-17.28 5.447-27.338 8.633-.654-1.144-2.29-4.088-4.826-8.531-6.105 1.253-12.701 2.614-20.932 4.302-5.207-3.244-9.789-16.163-19.953-3.819-3.136-4.988-5.29-8.449-7.444-11.911-.818.218-1.609.408-2.454.598-.353 2.862-.707 5.669-1.088 8.83-.3.137-1.608 1.009-1.799.818-6.761-7.033-15.181 5.693-23.196-2.158a952 952 0 0 1 8.666-5.612c-8.205-5.697-16.818-4.009-24.832-5.264-3.734-.573-8.886-2.128-10.441-4.881-6.68-11.911-17.937-12.976-29.985-14.668-2.209-3.244-4.881-7.06-7.471-10.903-6.271-9.267-13.876-14.965-24.587-9.816-6.025-4.226-11.723-7.416-16.33-11.695-4.471-4.144-2.62-13.3-12.541-14.992 3.463 9.24 3.52 18.942 14.123 23.55 4.88 2.099 7.143 6.488 7.471 12.429.219 4.306 2.564 8.776 4.855 12.647 9.788 16.599 20.23 32.817 29.665 49.607 3.326 5.942 11.313 7.987 11.751 16.436.301 5.696 3.028 11.257 5.155 18.506 9.051 6.761 13.005 18.29 15.433 30.691.409 2.044.929 5.233 2.264 5.751 6.052 2.399 4.853 8.34 4.799 11.938-.215 12.7 2.24 24.311 7.83 35.731 2.307 4.693 2.049 10.655 2.908 16.032l-.07.211c-2.698.626-5.424 1.226-9.513 2.206 3.381 6.269 4.364 11.938-4.494 14.798-6.132 1.988-3.351 7.331-3.023 13.163 5.587-3.079 9.894-5.422 14.745-8.092 9.488 13.629-.514 25.155-3.919 37.283l13.986 13.984-13.898 13.896a3900 3900 0 0 1 16.79-3.049c1.392 11.037-8.721 7.466-13.844 11.825.654 1.908 1.499 4.226 2.481 7.166-5.86 4.23-12.646 6.65-16.842 14.55-3.079 5.86-13.627 9.16-21.422 10.79-11.121 2.29-19.924 6.62-26.464 15.94-2.071 2.94-5.505 4.9-8.748 7.66.382 3.97.737 8.09 1.202 13.3-9.295.29-18.699-.17-27.803 1.13-4.061.58-8.34 4.09-11.201 7.39-4.387 5.09-8.803 8.04-15.618 5.8-1.226-.41-2.671-.44-3.925-.22-7.541 1.18-12.811-.87-15.81-6.16-7.877 2.81-15.836 4.82-22.976 8.47-5.015 2.56-8.885 7.36-13.708 11.53-4.279.35-2.157-16.33-12.24-5.37-1.063 1.17-8.505-3.55-13.384-5.7-.545 2.23-1.445 5.8-3.188 12.67-4.854-11.18-12.432-14.12-21.372-16.47l-6.922 6.92c-4.118-7.05-7.744-13.24-11.67-20-3.489.38-7.332.79-12.266 1.3.899-5.42 1.634-9.75 2.45-14.82-5.478-.19-10.33-.36-15.182-.52-3.297 4.11-6.377 7.96-9.538 11.88-3.544-5.78-6.571-10.71-9.597-15.65-7.931 2.65-11.041-5.64-16.983-7.55-7.387-2.37-12.513-7.44-16.166-14.26-4.745-8.83-10.852-15.91-21.237-18.94-4.852-1.42-10.986-3.03-12.023-10.277-.164-1.308-4.198-2.073-6.46-3.136.735-1.662 1.47-3.325 2.914-6.567-10.329 3.894-14.31-4.718-20.934-8.835.681-1.989 1.416-4.033 2.533-7.167-4.416.49-8.259.952-14.038 1.605 2.099-2.589 3.544-3.706 4.061-5.15.518-1.499.599-4.578.027-4.824-1.854-.763-5.398-1.418-6.052-.491-3.488 4.905-7.713 6.239-14.282 4.031 1.253-3.652 2.507-7.359 4.414-12.973-4.007-1.445-7.907-3.98-11.75-3.954-8.695.135-9.839-.029-9.486-7.96.244-5.968 1.306-11.882 2.122-18.75-6.242-.355-9.295-.683-12.348-.683-11.53.025-14.256-4.663-8.807-15.346.409-.79.463-1.771 1.09-4.469-4.825-.846-9.513-1.719-13.084-2.346-5.126-5.834-9.87-11.176-15.54-17.663a5929 5929 0 0 1 7.601-13.708c-5.478 1.88-9.076 3.133-13.327 4.604a1305 1305 0 0 0-4.554-10.004 971 971 0 0 1 6.514-2.969c.027-.627.108-1.09-.001-1.526-.136-.409-.381-.981-.736-1.118-8.559-3.326-9.843-17.035-22.599-14.912-7.332 1.225-7.523.162-13.249-9.214 6.679 1.5 12.403 2.756 18.155 4.038l1.007-2.917a18944 18944 0 0 0-26.961-16.82c-1.907 2.125-4.005 4.387-5.94 6.539-5.343-3.053-4.636-12.809.651-16.733q-7.552-8.313-2.076-23.33c-2.617.49-4.498.844-6.297 1.225-2.18.436-4.36.926-6.95 1.498 2.261-6.241 3.978-8.721 9.919-14.552-9.077-4.716-10.248 5.286-16.734 9.045 1.171-4.278 1.907-7.031 2.914-10.656-3.325-1.635-6.87-3.326-11.176-5.452 4.331-11.255-4.228-15.89-11.862-22.269 2.916-2.915 6.487-5.231 8.15-8.528 1.443-2.862.624-6.841.896-11.419-5.179.816-8.667 1.36-13.274 2.095-1.2-4.524-2.346-8.831-3.791-14.2 3.87-.871 6.787-1.551 10.575-2.45-.246-3.788-.492-7.74-.765-12.264-3.135 1.117-5.179 1.852-8.068 2.887-.41-11.202 6.89-26.244-13.825-28.646.409-2.317.871-5.233 1.525-8.993-2.862-1.445-5.943-3-10.168-5.154a5097 5097 0 0 1 10.49-21.664c-1.745-.273-4.662-.737-9.514-1.501 2.534-5.587 6.35-10.6 6.812-15.915.463-5.641-2.237-11.555-3.847-18.614-2.861 2.861-4.633 5.449-7.086 6.811-1.908 1.09-4.66.681-7.795-.001 7.6-5.209 10.168-12.149 9.677-20.47a2691 2691 0 0 1 14.303-11.957c-8.669-3.327-14.993-5.781-21.453-8.262q2.697-9.021 15.617-10.763c.405-12.593 2.035-14.843 13.257-18.643-1.121-1.467-2.853-2.862-3.094-4.438-.71-5.505.978-12.21-1.639-16.353-3.135-4.933-2.864-9.076-3.056-14.118-.136-2.916-1.745-4.633 2.07-6.158 1.309-.545 2.889-4.307 2.317-4.988-4.226-5.152-.275-8.994 4.085-14.225-5.588.734-8.532 1.116-10.849 1.415.245-4.824.49-9.703.843-16.271-3.87 1.035-5.888 2.07-7.85 2.016-6.76-.329-8.777-4.58-5.044-10.112 3.215-4.742 6.485-9.484 10.164-14.852-3.898-2.099-6.543-3.544-9.241-4.989 8.72-12.099 17.06-12.86 26.657-2.066 1.743-6.649 3.35-12.727 5.284-20.057 7.714 1.718 14.83 3.273 22.107 4.882.463-4.933.98-10.356 1.632-17.497 9.24.302 17.881.658 26.521.85 4.579.11 9.186.139 13.765-.133 13.602-.897 27.094-1.684 38.408 8.266 8.205 7.223 16.845 1.256 26.112.658 7.497 7.169 16.357 12.649 28.105 10.935 1.662-.245 4.197.272 5.206 1.39 12.187 14.038 30.206 21.046 41.33 37.073 6.98 10.085 19.9 16.138 30.341 23.689 4.798 3.435 10.441 5.698 15.157 9.215 8.451 6.379 16.739 13.03 24.617 20.145 3.626 3.298 6.08 7.932 9.843 13.002 5.696.192 10.468 3.817 16.192 7.906 11.45 8.178 19.575 20.009 31.024 27.151 10.359 6.434 13.714 15.565 17.123 25.186q14.146 1.447 19.405-9.536c-3.053-.6-5.806-1.118-9.05-1.746-2.018-5.233-1.611-12.291-10.906-13.465-5.124-.655-9.213-5.671-7.498-12.892.763-3.216-.845-6.95-1.446-10.984-6.351.026-11.53.08-16.709.079-.218-.763-.409-1.499-.627-2.262 1.935-1.444 3.87-2.888 6.84-5.095-3.898-5.479-7.825-10.931-11.778-16.464-3.788 2.043-7.304 3.923-12.156 6.539 3.895-17.578 3.731-17.96-10.308-25.62-.737-6.678-1.365-12.592-1.993-18.125-7.333-1.009-13.221-1.828-20.035-2.756 2.18-2.889 3.707-4.905 5.478-7.276-4.172-6.405-12.432-11.722-5.047-21.613-8.859-2.646-15.565-6.135-13.905-16.354.354-2.208-1.418-6.541-3.081-7.005-9.268-2.727-12.023-12.948-20.528-16.82-3.707-1.69-5.535-7.932-7.798-12.32-3.49-6.814-8.016-13.52-9.626-20.797-2.373-10.82-7.744-18.969-15.569-26.302-2.18-2.017-4.062-5.969-3.736-8.749 1.388-11.31-5.618-17.989-13.496-22.542-9.214-5.343-12.105-14.392-17.177-22.297-1.444-2.262-2.481-6.077-4.335-6.513-8.45-1.964-10.823-9.624-15.867-16.302-1.634 2.78-2.834 4.851-4.06 6.949q-7.415-6.488 5.775-21.311a1882 1882 0 0 0-10.215-3.334c-1.029 2.546-2.058 5.092-3.141 7.583-.844 1.935-1.853 3.815-5.587 5.368-.602-12.319-1.258-24.638-1.969-38.592 6.488 2.454 11.503 1.692 16.654-3.567-4.116-.518-7.415-.927-10.686-1.309q2.343-11.01-12.569-19.817c6.378-.979 10.93-1.715 16.926-2.64-1.936-3.952-3.518-7.277-5.127-10.575zm204.409 889.08c1.444-.9 2.889-1.8 4.36-2.72a612 612 0 0 0-4.172-6.57l-.027-.03a675 675 0 0 1-3.761 2.12zm113.966-410.636c-.163.654-.163 1.363-.245 2.044.681-.082 1.363-.163 2.072-.272l.027.027c-.245-.682-.437-1.363-.792-1.99-.083-.081-1.007.028-1.062.191m-9.463-23.195c-1.85 15.153-.923 16.407 9.68 14.692-2.972-4.552-5.863-8.913-9.68-14.692m-14.61-.547c.355.681.573 1.607 1.145 1.962.627.409 1.581.273 2.426.355-.055-.709-.081-1.39-.163-2.562l-.028.027c-1.117.082-2.235.164-3.38.218m-50.164-54.844c.71 8.067 9.297 13.546 2.73 20.767-.273.273 3.245 5.534 5.698 6.352 7.006 2.372 14.42 3.627 21.998 5.428 5.123-6.704-.548-10.248-4.746-13.138-6.379-4.416-14.066-6.87-16.684-15.646-.518-1.717-5.044-2.209-8.996-3.763m-13.845 6.32c2.044 1.826 4.089 3.707 6.133 5.534.627-.845 1.227-1.662 1.881-2.48-2.29-1.526-4.58-3.054-6.87-4.526zm-21.327-56.365c.082.681.082 1.391.328 2.017.056.164 1.036.273 1.091.164.3-.627.462-1.336.653-2.017-.682-.082-1.363-.11-2.044-.191zM116.762 800.281c-.736.953-1.418 1.907-2.153 2.86l6.052 3.763c.463-.682.953-1.39 1.416-2.071-1.799-1.526-3.571-3.026-5.343-4.58zm-17.566-62.578c-2.48 1.226-3.925 4.523-5.778 6.976.71.817 1.418 1.689 2.127 2.507a3030 3030 0 0 1 13.356-5.393c-5.153-2.318-8.234-4.799-9.705-4.09m-15.867-20.062 1.199-1.199-5.59-5.588-1.198 1.199zm438.66-527.246c2.562-.872 5.179-1.744 7.741-2.616l-.027-.027c-.245-.735-.518-1.444-.764-2.18-2.562.872-5.151 1.77-7.713 2.642zm-32.381 1.901c-3.352.626-5.124.49-5.451 1.143-.518.954-.49 2.943.137 3.57.654.655 2.834.71 3.57.084.899-.736.954-2.48 1.744-4.797M65.522 539.454c.273-.927.545-1.908.817-2.835l-5.31-.397zm281.402-338.898c.213.859.324 1.559.593 2.206.055.109 1.008.081 1.063-.082.245-.627.3-1.336.409-1.99-.671-.027-1.342-.105-2.065-.134M73.214 421.692c.272 1.145.518 2.317.791 3.461l7.114-3.024c-.355-.845-.683-1.716-1.037-2.561zm136.27-173.125c1.066-2.134 2.133-4.318 3.199-6.45-1.254-.218-2.509-.382-3.762-.6z",
    clipRule: "evenodd"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#by)",
    d: "M513.683 1088.86c.647-.27 1.347-.38 2.206-.59-.029.72-.108 1.4-.134 2.07-.682-.14-1.363-.17-1.99-.41-.163-.06-.191-1.01-.082-1.07"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bz)",
    d: "M515.918 1088.26c-.01.01-.02.01-.029.01l.002-.03z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bA)",
    d: "M643.821 901.191q10.264-3.073 11.161 9.269c-4.642-3.833-7.922-6.57-11.161-9.269"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bB)",
    d: "m643.821 901.191-.098.028.001-.109z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bC)",
    d: "m643.802 900.974-.012-.075.012-.034z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bD)",
    d: "M1247.22 280.143c.68.137 1.36.164 1.99.409.16.056.19 1.006.08 1.063-.65.269-1.35.379-2.21.592.03-.723.11-1.393.14-2.064"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bE)",
    d: "M1247.08 282.207v.034l-.03-.027z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bF)",
    d: "M642.491 856.933c.654-.218 1.336-.244 2.017-.326-.054.654-.108 1.363-.163 2.017-.681-.191-1.363-.328-1.99-.627-.109-.055-.027-1.009.136-1.064"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bG)",
    d: "M1153.11 215.281c-.25 1.112-.49 2.277-.71 3.416-.76-.273-2.15-.409-2.23-.818-.22-1.09.08-2.317.19-3.461.78.243 1.56.487 2.75.863"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bH)",
    d: "m1153.14 215.291-.03-.01v-.018z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bI)",
    d: "M298.445 1019.6c.681-.41 1.417-.82 2.098-1.22 1.2 2.01 2.4 4.03 3.599 6.05-.735.41-1.499.84-2.207 1.28-1.173-2.05-2.318-4.06-3.49-6.11"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bJ)",
    d: "M46.139 1233.66c.926-.28 1.853-.5 2.78-.77l5.809 17.53c-1.52.27-3.013.51-4.532.78-1.335-5.85-2.696-11.67-4.057-17.54"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bK)",
    d: "m50.196 1251.2.008.04-.028-.03c.007 0 .013 0 .02-.01"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bL)",
    d: "m45.755 1197.84-.027.03.013-.03z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bM)",
    d: "M46.545 1195.91c-.268.64-.536 1.28-.804 1.93-1.958-.82-3.943-1.66-5.928-2.45.3-.74.572-1.45.871-2.18 1.936.9 3.925 1.8 5.86 2.7"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bN)",
    d: "M1056.53 180.933c.74.028 1.42.109 2.1.136-.13.682-.19 1.391-.43 2.017-.06.164-1.04.218-1.07.082-.27-.654-.38-1.363-.6-2.235"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bO)",
    d: "M56.837 1147.45c-.736.96-1.417 1.91-2.153 2.87l-5.316-4.56 1.417-2.07c2.017 1.26 4.034 2.51 6.052 3.76"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bP)",
    d: "M792.828 336.867c1.892.643 3.43.729 3.891 1.461.436.763-.246 2.153-.409 3.243-.818-.218-2.017-.164-2.372-.682-.596-.866-.628-2.082-1.11-4.022"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bQ)",
    d: "m792.828 336.867-.035-.012.027-.027z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bR)",
    d: "M-79.302 926.374c8.912-5.367 16.706-10.162 24.555-14.793 13.846-8.174 22.132-7.682 33.991 3.031 7.988 7.169 14.831 15.646 23.01 22.515 10.495 8.86 20.228 19.136 35.928 19.357 3.98.056 8.015 5.18 11.723 8.288 3.216 2.726 6.024 5.915 10.304 10.195-1.715 6.35 1.639 12.7 6.983 19.078 6.816 8.175 6.053 10.795-.297 19.485-1.907 2.62-2.642 6.08-4.032 9.38-3.107-.49-6.624-1.01-9.949-1.5-7.656 15.23-20.113 17.54-35.404 19.91-14.418 2.26-24.015-6.14-36.172-7.88-6.187-.9-10.14-5.62-13.44-12.41-8.017-16.4-17.315-32.294-28.03-47.259-5.37-7.55-11.178-15.209-14.587-23.685-3.163-7.904-3.41-17.035-4.611-23.794z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bS)",
    d: "M89.26 799.488c.03-.246 2.125-.708 2.208-.518.818 1.418 1.31 2.999 1.936 4.498a82 82 0 0 0-.763 2.78c-1.117-.627-2.835-.982-3.217-1.909-.572-1.444-.354-3.244-.164-4.851"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bT)",
    d: "M775.586 29.894c.6-.763 2.318-.681 4.007-1.062l.027-.027c.218 1.689.791 3.841.465 3.952-1.363.6-2.972.572-4.498.79-.055-1.255-.6-2.89-.001-3.653"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bU)",
    d: "M539.02 156.251c.79-.682 2.453-.382 4.47-.545-.272 1.689-.108 3.434-.762 3.87-.954.572-2.535.19-3.816.217-.001-1.253-.492-3.052.108-3.542"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bV)",
    d: "M21.655 625.896c-.027-.137 2.232-.653 2.262-.573.791 2.208 1.391 4.443 2.046 6.678-1.145.218-2.29.436-3.407.681l-.028.027c-.354-2.262-.709-4.524-.873-6.813"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bW)",
    d: "M499.521 151.637c-.109-.109.49-.871.626-.844.655.163 1.282.518 1.936.791-.436.545-.818 1.09-1.254 1.635-.464-.518-.954-1.009-1.308-1.582"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bX)",
    d: "M29.938 595.701c-.164.709-.136 1.772-.572 2.044-.627.409-1.69.436-2.426.191-.327-.109-.354-1.227-.6-2.29l-.027-.027c1.28.027 2.453.054 3.625.082"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bY)",
    d: "M39.038 585.781v.108l-.229-.054z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZ)",
    d: "m39.069 585.748-.005.005v-.11z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ca)",
    d: "M38.81 585.835c-1.51.363-3.065.727-4.57 1.09v-2.181c1.505.364 3.06.728 4.57 1.091"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cb)",
    d: "M12.054 595.314c.6-.327 1.282-.518 1.936-.79l.245 2.043c-.654-.054-1.363-.054-2.017-.218-.163-.055-.3-.952-.164-1.035"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cc)",
    d: "M415.242 137.829c1.145.11 2.263.41 3.762.764l.028-.027c-.927.926-1.39 1.771-1.962 1.853-.736.082-1.664-.3-2.263-.791-.217-.219.352-1.82.435-1.799"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cd)",
    d: "M29.801 470.334c.654-.272 1.361-.381 2.205-.571-.052.689-.08 1.353-.133 2.043-.654-.109-1.363-.164-1.99-.409-.163-.055-.19-1.008-.082-1.063"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ce)",
    d: "m32.009 469.762-.003.001.004-.055z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cf)",
    d: "M-121 267.892c2.888-6.54 8.039-10.218 15.072-10.544 12.592-.597 26.793-4.492 37.397-.047 10.631 4.471 23.197 7.935 31.758 18.457 13.905 17.063 35.467 23.035 55.34 34.84h-.055c.955 7.113 3.055 14.173 11.397 16.954.409.137.927.6.954.954 1.366 14.118 13.525 26.657 6.577 42.599-2.644-.355-4.825-.628-7.66-1.01.192 3.406.328 6.05.547 9.865-9.84-.737-11.692 8.856-16.679 14.279-4.796 5.231-8.584 6.948-15.235 5.747-6.297-1.118-13.11.134-19.162-1.557-6.024-1.663-11.559-5.398-16.956-8.724-6.652-4.144-13.44-8.261-19.247-13.413-5.48-4.879-9.079-11.911-14.668-16.573-15.838-13.221-23.392-32.982-38.55-47.156 1.417-2.943 4.278-6.077 3.814-8.666-.463-2.807-4.035-5.07-6.543-7.905 1.308-1.58 2.97-3.624 5.559-6.757-11.639-2.864-7.499-14.855-13.66-21.343"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cg)",
    d: "M28.193 13.726c1.661-6.73 13.955-4.74 24.287 4.011 3.325-2.016 6.405-4.386 9.893-5.857 3.352-1.444 7.114-1.988 11.747-3.186-.054-.055.873 1.09 2.018 1.744 7.442 4.008 8.807 17.853 21.508 13.386 8.151 5.043 16.901 7.09 26.577 7.064 3.898-.027 7.633 4.252 11.722 5.834 11.721 4.526 23.607 8.562 35.355 13.007 2.89 1.09 7.633 2.672 7.879 4.498 1.583 11.937 11.26 15.183 19.683 19.954.764.436 1.255 1.308 2.645 2.862-1.662 4.17-3.514 8.802-5.339 13.407 6.324 7.632 6.435 17.226-.214 24.419-8.53 9.183-17.006 18.475-26.299 26.84-5.014 4.524-11.528 7.602-17.688 10.653-2.262 1.117-5.56.545-8.259.135-2.725-.382-7.141-.928-7.714-2.481-4.582-12.865-20.935-8.072-27.152-19.028-5.235-9.213-12.432-16.901-23.581-20.582-7.85-2.564-8.043-11.966-9.408-18.562-1.364-6.65-3.681-10.33-9.515-13.71-4.389-2.535-9.214-7.251-10.415-11.885-4.119-15.616-17.013-24.367-26.065-36.143l-.027-.136c2.125-2.343 4.333-4.714 6.977-7.63z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 131.5,
    x2: 1231.5,
    y1: 365.5,
    y2: 1850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823F0E",
    stopOpacity: 0
  })))));
};
export default SvgOrangePawBackground;